import { render, staticRenderFns } from "./CoIslandCreateButton.vue?vue&type=template&id=4cf63825&scoped=true&"
import script from "./CoIslandCreateButton.vue?vue&type=script&lang=ts&"
export * from "./CoIslandCreateButton.vue?vue&type=script&lang=ts&"
import style0 from "./CoIslandCreateButton.vue?vue&type=style&index=0&id=4cf63825&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf63825",
  null
  
)

export default component.exports